import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';
import { LearnMoreLink, Text } from '@ui/themed';
import type { ReactNode } from 'react';

/**
 * One row of a settings list: label and description on the left, the control on the right.
 * Callers wrap `control` in whatever width or stacking it needs.
 */
export function SettingRow({
  label,
  description,
  learnMoreUrl,
  control,
  tooltip,
  mono,
  truncate,
  align = 'start',
}: {
  label: ReactNode;
  description?: ReactNode;
  learnMoreUrl?: string;
  control: ReactNode;
  tooltip?: string;
  mono?: boolean;
  truncate?: boolean;
  align?: 'start' | 'center';
}) {
  return (
    <div
      title={tooltip}
      className={cn(
        'flex justify-between gap-4',
        align === 'center' ? 'items-center' : 'items-start',
      )}
    >
      <div className="flex min-w-0 flex-1 flex-col">
        <Text>{label}</Text>
        {(description || learnMoreUrl) && (
          <Text size="sm" variant="secondary" mono={mono} truncate={truncate}>
            {description}
            {learnMoreUrl && (
              <>
                {' '}
                <LearnMoreLink link={learnMoreUrl} />
              </>
            )}
          </Text>
        )}
      </div>
      {control}
    </div>
  );
}
